import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';


const styles = theme => ({
    root: {
        backgroundColor: theme.palette.grey[400],
        height: 16,
        borderRadius: theme.youwell.shapes.borderRadius,
        width: 200,
    },
    fill: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.youwell.shapes.borderRadius,
        height: '100%',
    },
});

const ProgressBar = (props) => {
    const { classes, className, value } = props;

    return (
        <div className={classnames(classes.root, className)}>
            <div
                className={classes.fill}
                style={{ width: `${Math.min(Math.max(value, 0), 1) * 100}%` }}
            />
        </div>
    );
};

ProgressBar.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    value: PropTypes.number,
};

ProgressBar.defaultProps = {
    className: null,
    value: 0,
};

export default withStyles(styles)(ProgressBar);
